/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    ProductListSavings,
    ProductSingleSavings,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [ProductListSavings.blockKey]: { render: ProductListSavings },
    [ProductSingleSavings.blockKey]: { render: ProductSingleSavings },
};

export default BLOCK_TO_COMPONENT_MAP;
